import type { CanonicalWork } from "../generated/contracts";

export type PlayerState = {
  current: CanonicalWork | null;
  queue: CanonicalWork[];
  playing: boolean;
  rate: number;
  sleepAt: number | null;
};

export type PlayerAction =
  | { type: "load"; work: CanonicalWork; queue?: CanonicalWork[] }
  | { type: "toggle" }
  | { type: "pause" }
  | { type: "rate"; rate: number }
  | { type: "sleep"; sleepAt: number | null }
  | { type: "queue"; queue: CanonicalWork[] }
  | { type: "advance"; direction: -1 | 1 };

export const initialPlayerState: PlayerState = {
  current: null,
  queue: [],
  playing: false,
  rate: 1,
  sleepAt: null,
};

export function playerReducer(
  state: PlayerState,
  action: PlayerAction,
): PlayerState {
  if (action.type === "load")
    return {
      ...state,
      current: action.work,
      queue: action.queue || [action.work],
      playing: true,
    };
  if (action.type === "toggle") return { ...state, playing: !state.playing };
  if (action.type === "pause") return { ...state, playing: false };
  if (action.type === "rate") return { ...state, rate: action.rate };
  if (action.type === "sleep") return { ...state, sleepAt: action.sleepAt };
  if (action.type === "queue") return { ...state, queue: action.queue };
  if (action.type === "advance" && state.current) {
    const index = state.queue.findIndex(
      (work) => work.id === state.current?.id,
    );
    const next = state.queue[index + action.direction];
    return next
      ? { ...state, current: next, playing: true }
      : { ...state, playing: false };
  }
  return state;
}
